import * as React from "react"
import "../../en.css"
import config from "../../../../utils/config"
import request from "../../../../utils/request"

interface IStateInstructor {
    list: []
}
interface IPropsInstructor {
    shopInfo: any
}

export default class Socialize extends React.Component < IPropsInstructor, IStateInstructor > {
    public constructor(props: IPropsInstructor) {
        super(props)

        this.state = {
            list: []
        }
    }

    public componentDidMount() {
        this.getData()
    }

    public componentDidUpdate(prevProps) {
        if (this.props.shopInfo.shop_id !== prevProps.shopInfo.shop_id) {
            // 如果 shopInfo 发生了变化，执行某些操作
            console.log(this.props.shopInfo)
        }
    }

    public render() {
        return (
            <div className="yqlink">
		        <div className="container">
		          <div className="link-logo">
                  {
                      this.props.shopInfo && <a href="/">
                          <img src={this.props.shopInfo.mobile_logo} alt="" />
                      </a>
                  }
		          </div>
		          <ul>
                      {
                          this.state.list.map((item: any) => {
                              return <li key={item.social_media_id}><a href={item.social_url}><img src={item.social_img}/></a></li>
                          })
                      }
		          </ul>
		        </div>
		    </div>
        )
    }

    private async getData() {
        const r = await request({
            data: {
                shopDomain: (window as any).shopId
            },
            method: "post",
            url: `${config.PHPAPI}api/wshop/shop/media`,
        })

        if (r.error_code === 0) {
            console.log(r)
            this.setState({
                list: r.data
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/shop_en/common/socialize/index.tsx